import { addFontsToHead } from './add-fonts-to-head';
import { addMsoStylesToRawHtml } from './add-mso-styles';
import { addSiteInfo } from './add-site-info';
import { addStyleFixes } from './add-style-fixes';
import { hidePixel } from './hide-pixel';
import { insertAd } from './insert-ad';
import { modifyPreviewText } from './modify-preview-text';
import { ensureMjHead } from './ensure-mj-head';
const DEFAULT_PARSING_OPTIONS = {
  keepComments: false,
  validationLevel: 'skip',
  minify: true
};
export const renderMjml = _ref => {
  let mjml = _ref.mjml,
    preheader = _ref.preheader,
    t = _ref.t,
    mjml2html = _ref.mjml2html,
    options = _ref.options,
    customFonts = _ref.customFonts;
  let email = mjml;
  email = ensureMjHead(email);
  email = modifyPreviewText(email, preheader);
  email = addFontsToHead(email, customFonts);
  email = addMsoStylesToRawHtml(email);
  email = options.showAd ? insertAd(email, t) : email;
  const withSiteInfo = addSiteInfo(email, options, t);
  const withStyleAdjustments = addStyleFixes(withSiteInfo);
  return mjml2html(hidePixel(withStyleAdjustments), DEFAULT_PARSING_OPTIONS).html;
};
//# sourceMappingURL=render-mjml.js.map